export default __webpack_public_path__ + "static/media/search.5b52a5a9.svg";